module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step3-ES.e28d67b6.png";